import React from 'react';
import PropTypes from 'prop-types';
import { AlertContent, AlertFooter, AlertButtons } from 'assets/styles/sharedStyles';
import { getItemPrice } from 'selectors/browse';
import { getComboUpsellMessage } from 'selectors/root';
import { List } from 'immutable';
import { connect } from 'react-redux';
import ActionButton from '../../../ActionButton';
import { Container } from '../ConfirmLocationAlert/styles';
import OrderComboUpsells from '../../../OrderReview/OrderComboUpsells';

const ComboUpsellAlert = ({
  menuTypeId,
  sectionProducts,
  onAccept,
  onDecline,
  getItemPrice,
  serviceId,
  comboUpsellMessage,
}) => (
  <AlertContent>
    <Container>
      <OrderComboUpsells
        comboUpsellsList={sectionProducts}
        menuTypeId={menuTypeId}
        serviceId={serviceId}
        comboUpsellMessage={comboUpsellMessage}
        onAccept={onAccept}
        getItemPrice={getItemPrice}
      />
    </Container>

    <AlertFooter>
      <AlertButtons>
        <ActionButton label="No Thanks" onClick={onDecline} />
      </AlertButtons>
    </AlertFooter>
  </AlertContent>
);

ComboUpsellAlert.propTypes = {
  menuTypeId: PropTypes.number.isRequired,
  sectionProducts: PropTypes.instanceOf(List).isRequired,
  serviceId: PropTypes.string.isRequired,
  comboUpsellMessage: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  getItemPrice: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  getItemPrice: (price, taxCategories) => getItemPrice(state, price, taxCategories),
  comboUpsellMessage: getComboUpsellMessage(state, ownProps.serviceId),
});

export default connect(mapStateToProps)(ComboUpsellAlert);
